import { useEffect, useState } from 'react'
import {ChevronDown} from 'lucide-react'

const FOTO_MONICA = 'https://static.lumi.new/b2/b2c0441cd263f605e6a1cd0bab42c1dc.webp'
const PRINT_ELISANGELA = 'https://static.lumi.new/ed/ed7571113db96839e50223073b3e6ef4.webp'
const LINK_JORNADA = 'https://pay.hotmart.com/T107316970V?off=pe7x8qb8'
const LINK_KIT_BRASIL = 'https://doterra.me/AHXLg8'

const SENSACOES = [
  'Você sente que carrega um peso que ninguém vê',
  'Você já tentou mudar, mas algo sempre puxa de volta',
  'Você sabe que tem bloqueios, mas não sabe como acessá-los',
  'Você vive no automático e por dentro sente que está sufocando',
  'Você quer se transformar, mas o tempo, o dinheiro e o cansaço falam mais alto',
]

const PASSOS_JORNADA = [
  {
    numero: 1,
    titulo: 'Use o óleo essencial da vivência',
    descricao:
      'Ao abrir a vivência, você recebe a orientação de como usar o óleo daquela emoção.',
  },
  {
    numero: 2,
    titulo: 'Responda o questionário de liberação',
    descricao:
      'Seguindo a orientação, você escreve com honestidade sobre as dores e lembranças que estão te prendendo, no seu ritmo.',
  },
  {
    numero: 3,
    titulo: 'Receba o seu relatório',
    descricao:
      'Você recebe um relatório com tudo o que abriu e expressou, como continuar liberando essas dores junto com o óleo essencial e outras formas de usá-lo no seu dia a dia.',
  },
]

const FAQ = [
  {
    pergunta: 'Preciso ter os óleos essenciais para fazer a jornada?',
    resposta:
      'Você pode viver a jornada mesmo tendo apenas a Lavanda. Mas para ter o resultado e a transformação completa, o recomendado é ter todos os óleos do Kit Brasil dōTERRA. Se ainda não tem, você pode adquirir pelo botão abaixo.',
    cta: {
      label: 'QUERO COMPRAR O KIT BRASIL dōTERRA',
      href: LINK_KIT_BRASIL,
    },
  },
  {
    pergunta: 'Posso fazer mais de uma vivência por dia?',
    resposta:
      'Sim. Você avança no seu ritmo. Pode fazer uma vivência por dia ou concluir toda a jornada em um único dia.',
  },
  {
    pergunta: 'Meus dados ficam salvos em algum lugar?',
    resposta:
      'Não. Suas respostas são processadas apenas para gerar seu relatório e não ficam armazenadas. Apenas você recebe o relatório no seu e-mail.',
  },
  {
    pergunta: 'Quanto tempo tenho para concluir?',
    resposta: 'Você tem 30 dias a partir do acesso para concluir todas as vivências.',
  },
  {
    pergunta: 'Posso refazer a jornada em outro momento?',
    resposta:
      'Sim. Você pode refazer a Jornada sempre que sentir que é importante liberar novos bloqueios emocionais. Basta se inscrever novamente.',
  },
]

function FaqItem({
  pergunta,
  resposta,
  cta,
}: {
  pergunta: string
  resposta: string
  cta?: { label: string; href: string }
}) {
  const [aberto, setAberto] = useState(false)

  return (
    <div className="border border-[#EDE0D4] rounded-2xl overflow-hidden bg-white">
      <button
        type="button"
        aria-expanded={aberto}
        onClick={() => setAberto(!aberto)}
        className="w-full flex items-center justify-between px-5 sm:px-6 py-4 min-h-[48px] text-left bg-white hover:bg-[#F8F4EF] transition-colors"
      >
        <span className="font-medium text-[#2C2C2A] text-sm md:text-base pr-4">{pergunta}</span>
        <ChevronDown
          className={`w-4 h-4 text-[#2D6A4F] shrink-0 transition-transform ${aberto ? 'rotate-180' : ''}`}
        />
      </button>
      {aberto ? (
        <div className="px-5 sm:px-6 py-4 bg-[#F8F4EF] border-t border-[#EDE0D4]">
          <p className="text-[#5F5E5A] text-sm leading-relaxed">{resposta}</p>
          {cta ? (
            <a
              href={cta.href}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex w-full sm:w-auto items-center justify-center rounded-full bg-[#1D5C3A] px-6 py-3 font-dm-sans text-[12px] font-semibold uppercase tracking-[0.06em] text-white hover:bg-[#164a2e] focus:outline-none focus:ring-2 focus:ring-[#C9A84C] focus:ring-offset-2 focus:ring-offset-[#F8F4EF] transition-colors"
            >
              {cta.label}
            </a>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

function CtaJornada({ variante }: { variante: 'hero' | 'preco' }) {
  const classes =
    variante === 'hero'
      ? 'bg-[#C9A84C] text-[#1D5C3A] hover:bg-[#d4b45e]'
      : 'bg-[#C9A84C] text-[#1D5C3A] hover:bg-[#d4b45e]'

  return (
    <a
      href={LINK_JORNADA}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex w-full sm:w-auto items-center justify-center rounded-full px-7 py-4 font-dm-sans text-[13px] sm:text-sm font-semibold tracking-[0.08em] uppercase transition-colors focus:outline-none focus:ring-2 focus:ring-[#C9A84C] focus:ring-offset-2 ${classes} ${
        variante === 'hero' ? 'focus:ring-offset-[#1D5C3A]' : 'focus:ring-offset-[#1D5C3A]'
      }`}
    >
      Quero começar minha jornada
    </a>
  )
}

export default function Jornada12Emocoes() {
  useEffect(() => {
    document.title = 'Jornada das 12 Emoções — Diagnóstico Saúde e Emoções'
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen bg-[#E8F2EC] font-dm-sans text-[#2C2C2A]">
      {/* SEÇÃO 1 — HERO */}
      <section className="relative overflow-hidden bg-[#1D5C3A] px-4 py-16 sm:py-24">
        <div
          className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#C9A84C]/70 to-transparent"
          aria-hidden="true"
        />
        <div className="relative mx-auto max-w-[640px] text-center">
          <p className="mb-5 font-dm-sans text-[11px] font-medium uppercase tracking-[0.28em] text-[#C9A84C]">
            Jornada das 12 Emoções
          </p>
          <h1 className="font-cormorant text-[34px] leading-[1.15] font-semibold text-white sm:text-5xl">
            Você não está presa na dor.
            <span className="mt-2 block text-[#C9A84C]">
              Você está presa sem uma porta de saída.
            </span>
          </h1>
          <p className="mx-auto mt-6 max-w-[520px] text-[16px] leading-relaxed text-white/85 sm:text-lg">
            São 12 vivências transformadoras com 12 óleos essenciais para liberar o que te prende, elevar sua vibração e criar uma nova vida.
          </p>
          <div className="mt-9">
            <CtaJornada variante="hero" />
          </div>
        </div>
      </section>

      {/* SEÇÃO 2 — A DOR */}
      <section className="bg-white px-4 py-16 sm:py-20">
        <div className="mx-auto max-w-[640px]">
          <h2 className="font-cormorant text-[28px] leading-tight font-semibold text-[#1D5C3A] sm:text-4xl">
            Você reconhece alguma dessas sensações?
          </h2>
          <ul className="mt-8 space-y-3">
            {SENSACOES.map((item, index) => (
              <li
                key={item}
                className="flex gap-4 border-l-[3px] border-[#C9A84C] bg-[#E8F2EC]/60 px-4 py-3.5"
              >
                <span className="mt-0.5 font-cormorant text-lg font-semibold text-[#C9A84C]">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="text-[15px] leading-relaxed text-[#2C2C2A]">{item}</span>
              </li>
            ))}
          </ul>
          <p className="mt-8 text-[16px] leading-relaxed text-[#5F5E5A]">
            Se você se reconheceu em pelo menos uma dessas frases, essa jornada foi criada para você.
          </p>
        </div>
      </section>

      {/* SEÇÃO 3 — O QUE VOCÊ VAI VIVER */}
      <section className="bg-[#E8F2EC] px-4 py-16 sm:py-20">
        <div className="mx-auto max-w-[640px]">
          <p className="mb-3 font-dm-sans text-[11px] font-medium uppercase tracking-[0.24em] text-[#C9A84C]">
            12 portas
          </p>
          <h2 className="font-cormorant text-[28px] leading-tight font-semibold text-[#1D5C3A] sm:text-4xl">
            12 emoções. 12 óleos. 12 portas de transformação.
          </h2>
          <p className="mt-6 text-[16px] leading-relaxed text-[#2C2C2A] sm:text-lg">
            Cada vivência te convida a ir ao fundo do que dói, liberar o que prende e declarar quem você já é na sua essência mais elevada. Você avança no seu ritmo. É uma experiência terapêutica profunda. E é completamente sua.
          </p>
        </div>
      </section>

      {/* SEÇÃO 4 — COMO FUNCIONA NA PRÁTICA */}
      <section className="bg-[#F8F4EF] px-4 py-16 sm:py-20">
        <div className="mx-auto max-w-[640px]">
          <h2 className="font-cormorant text-[28px] leading-tight font-semibold text-[#1D5C3A] sm:text-4xl">
            Como funciona na prática
          </h2>
          <p className="mt-6 text-[16px] leading-relaxed text-[#2C2C2A] sm:text-lg">
            Ao se inscrever, você recebe um link de acesso para começar a sua Jornada das 12 Emoções. Cada vivência segue o mesmo caminho, em três passos:
          </p>

          <ol className="mt-8 space-y-4">
            {PASSOS_JORNADA.map((passo) => (
              <li
                key={passo.titulo}
                className="flex gap-4 rounded-2xl border border-[#EDE0D4] bg-white px-4 py-5 sm:px-5"
              >
                <span
                  aria-hidden="true"
                  className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[#C9A84C] font-cormorant text-base font-semibold text-[#1D5C3A]"
                >
                  {passo.numero}
                </span>
                <div>
                  <p className="font-cormorant text-xl leading-snug font-semibold text-[#1D5C3A]">
                    {passo.titulo}
                  </p>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-[#5F5E5A]">
                    {passo.descricao}
                  </p>
                </div>
              </li>
            ))}
          </ol>

          <p className="mt-8 text-[16px] leading-relaxed text-[#2C2C2A] sm:text-lg">
            Assim, a cada vivência, você libera uma emoção e ainda aprende a usar um óleo essencial.
          </p>
        </div>
      </section>

      {/* SEÇÃO 5 — PRIVACIDADE */}
      <section className="bg-white px-4 py-16 sm:py-20">
        <div className="mx-auto max-w-[640px]">
          <h2 className="font-cormorant text-[28px] leading-tight font-semibold text-[#1D5C3A] sm:text-4xl">
            Sua jornada é completamente sua
          </h2>
          <p className="mt-6 text-[16px] leading-relaxed text-[#2C2C2A] sm:text-lg">
            O que você escrever aqui não fica armazenado em nenhum lugar. Ninguém terá acesso. Apenas você recebe o relatório personalizado no seu e-mail. Você pode ir fundo com total honestidade.
          </p>
        </div>
      </section>

      {/* SEÇÃO 6 — BIO */}
      <section className="bg-[#E8F2EC] px-4 py-16 sm:py-20">
        <div className="mx-auto flex max-w-[640px] flex-col items-center gap-6 sm:flex-row sm:items-start sm:gap-8">
          <img
            src={FOTO_MONICA}
            alt="Mônica Maria, terapeuta vibracional"
            width={128}
            height={128}
            className="h-28 w-28 shrink-0 rounded-full border-[3px] border-[#C9A84C] object-cover shadow-sm sm:h-32 sm:w-32"
          />
          <div>
            <p className="font-cormorant text-2xl font-semibold text-[#1D5C3A]">Mônica Maria</p>
            <p className="mt-1 text-sm tracking-wide text-[#C9A84C]">Terapeuta Vibracional</p>
            <p className="mt-4 text-[15px] leading-relaxed text-[#2C2C2A] sm:text-base">
              Sou Mônica Maria, Terapeuta Vibracional. Meu trabalho é te ajudar a identificar o que está te prendendo e elevar sua vibração para que você crie a vida que merece. A Jornada das 12 Emoções nasceu de anos acompanhando mulheres que sabiam que algo precisava mudar e que só precisavam de uma porta de entrada.
            </p>
          </div>
        </div>
      </section>

      {/* SEÇÃO 7 — DEPOIMENTO */}
      <section className="bg-white px-4 py-16 sm:py-20">
        <div className="mx-auto max-w-[640px] text-center">
          <h2 className="font-cormorant text-[28px] leading-tight font-semibold text-[#1D5C3A] sm:text-4xl">
            O que quem já viveu diz
          </h2>
          <figure className="mt-8">
            <img
              src={PRINT_ELISANGELA}
              alt="Depoimento de Elisângela Longarai sobre a Jornada das 12 Emoções"
              width={640}
              height={720}
              className="mx-auto w-full max-w-[420px] rounded-2xl border border-[#EDE0D4] shadow-sm"
              loading="lazy"
            />
            <figcaption className="mt-4 font-cormorant text-xl font-semibold text-[#1D5C3A]">
              Elisângela Longarai
            </figcaption>
          </figure>
        </div>
      </section>

      {/* SEÇÃO 8 — PREÇO E CTA */}
      <section className="bg-[#1D5C3A] px-4 py-16 sm:py-20">
        <div className="mx-auto max-w-[640px] text-center">
          <h2 className="font-cormorant text-[32px] leading-tight font-semibold text-white sm:text-4xl">
            Comece sua jornada hoje
          </h2>
          <p className="mt-6 font-dm-sans text-lg text-[#C9A84C] line-through decoration-[#C9A84C]/80">
            De R$ 497,00
          </p>
          <p className="mt-1 font-cormorant text-[42px] leading-none font-semibold text-white sm:text-5xl">
            Por apenas <span className="text-[#C9A84C]">R$ 97,00</span>
          </p>
          <div className="mt-9">
            <CtaJornada variante="preco" />
          </div>
        </div>
      </section>

      {/* SEÇÃO 8 — FAQ */}
      <section className="bg-[#E8F2EC] px-4 py-16 sm:py-20">
        <div className="mx-auto max-w-[640px]">
          <h2 className="font-cormorant font-semibold text-[#2C2C2A] text-2xl sm:text-3xl mb-7 text-center">
            Perguntas frequentes
          </h2>
          <div className="space-y-3">
            {FAQ.map((item) => (
              <FaqItem
                key={item.pergunta}
                pergunta={item.pergunta}
                resposta={item.resposta}
                cta={item.cta}
              />
            ))}
          </div>
          <p className="mt-8 text-center">
            <a
              href="https://wa.me/5581988671210"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-[#2D6A4F] underline hover:opacity-80 transition-opacity"
            >
              Dúvidas? Fale com a Mônica
            </a>
          </p>
        </div>
      </section>
    </div>
  )
}
